import styled from 'styled-components';

export const Container = styled.div`
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 0;
    transform: rotate(${({ $show }) => ($show ? '180deg' : '0deg')});
    transition: 0.7s;
  }
`;
